"use strict";

import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getCurrentClient } from './client';
import { AUTH_REDIRECT_APP } from '@autoguru/global-configs';
import { TENANT_NAME, REGION } from '@autoguru/global-configs';
export const login = function login(returnTo) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    allow_socials = true,
    initialScreen = 'signUp',
    logoUrl,
    termsAndConditionsUrl,
    privacyPolicyUrl
  } = _objectSpread({
    allow_socials: true,
    initialScreen: 'login'
  }, options);
  getCurrentClient().loginWithRedirect({
    authorizationParams: {
      disallow_social: allow_socials ? void 0 : !allow_socials,
      initial_screen: initialScreen,
      redirect_uri: `${AUTH_REDIRECT_APP}?ag-target=${returnTo}`,
      logoUrl,
      termsAndConditionsUrl,
      privacyPolicyUrl,
      autoguru_tenant: TENANT_NAME,
      autoguru_region: REGION
    }
  });
};
export const signup = function signup(returnTo) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    allow_socials = true,
    initialScreen = 'signUp',
    token,
    logoUrl,
    termsAndConditionsUrl,
    privacyPolicyUrl
  } = _objectSpread({
    allow_socials: true,
    token: '',
    initialScreen: 'signUp'
  }, options);
  getCurrentClient().loginWithRedirect({
    authorizationParams: {
      lead_guid: token,
      redirect_uri: `${AUTH_REDIRECT_APP}?ag-target=${returnTo}`,
      initial_screen: initialScreen,
      disallow_social: allow_socials ? void 0 : !allow_socials,
      logoUrl,
      termsAndConditionsUrl,
      privacyPolicyUrl,
      autoguru_tenant: TENANT_NAME,
      autoguru_region: REGION
    }
  });
};
export const logout = function logout(returnTo) {
  let localOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return void getCurrentClient().logout({
    logoutParams: {
      returnTo: `${AUTH_REDIRECT_APP}?ag-target=${returnTo}`,
      localOnly
    }
  });
};